import React from 'react';
import PropTypes from 'prop-types';
//Mui
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ReactPlayer from 'react-player';
//MUI-Icon
import {DoubleArrow, KeyboardArrowLeft, KeyboardArrowRight} from '@material-ui/icons';

//Local
import {useCapacitacionesStyles} from '../CapacitacionesStyle';
import {GroupBoxColor} from 'lib.front';

/**
 *
 * @param {*} ArrObjetos
 * @param {*} setIndex
 * @param {*} index
 * @param {*} className
 * @returns Controla todas las capacitaciones de forma
 * global de aceuerdo al arreglo ArrObjetos.
 */
export const InfoContainer = ({ArrObjetos, setIndex, index, className}) => {
   const classes = useCapacitacionesStyles();

   const handleOnClickNextTutorial = () => {
      if (index < ArrObjetos.length - 1) {
         setIndex(index + 1);
      }
   };
   const handleOnClickBeforeTutorial = () => {
      if (index > 0) {
         setIndex(index - 1);
      }
   };
   const handleOnClickNextVideo = () => {
      if (index !== ArrObjetos.length - 1) {
         let auxIndex = index + 1;
         while (ArrObjetos[auxIndex].url === null || ArrObjetos[auxIndex].url === '') {
            auxIndex = auxIndex + 1;
            if (auxIndex === ArrObjetos.length) {
               break;
            }
         }
         setIndex(auxIndex);
      }
   };
   const handleOnClickBeforeVideo = () => {
      if (index !== 0) {
         let auxIndex = index - 1;
         while (ArrObjetos[auxIndex].url === null || ArrObjetos[auxIndex].url === '') {
            auxIndex = auxIndex - 1;
            if (auxIndex === 0) {
               break;
            }
         }
         setIndex(auxIndex);
      }
   };

   console.log(ArrObjetos[index]);

   return (
      <Grid container item alignItems="center" className={className}>
         {ArrObjetos[index] === undefined || ArrObjetos[index] === null ? (
            <Skeleton variant="rect" width="100%" height="360px" />
         ) : (
            <>
               <Grid container item xs={12} justify="center">
                  <Typography variant="h4" className={classes.TituloPrincipal} gutterBottom>
                     {ArrObjetos[index].denominacion}
                  </Typography>
               </Grid>
               <Grid
                  container
                  item
                  xs={12}
                  justify="center"
                  alignItems="center"
                  style={{margin: '0.5rem 0'}}
               >
                  {!ArrObjetos[index].url && (
                     <>
                        <img
                           className={classes.IMG}
                           src="https://www.dscont.pe/wp-content/uploads/2022/04/fondo-banner.jpg"
                        />
                        <Typography>Continuemos con el Tutorial</Typography>
                     </>
                  )}
                  {ArrObjetos[index].url && (
                     <ReactPlayer url={ArrObjetos[index].url} width="100%" />
                  )}
               </Grid>

               <Grid container item className={classes.contenedorInfo}>
                  {ArrObjetos[index].descripcion && ArrObjetos[index].descripcion.length > 5 && (
                     <Grid container item>
                        <GroupBoxColor
                           title={'Observaciones'}
                           borderColorPaper={'#ff5722'}
                           titlePosition={'TopL'}
                           borderRadiusPaper={'20'}
                        >
                           <Typography style={{textAlign: 'justify'}}>
                              {ArrObjetos[index].descripcion}
                           </Typography>
                        </GroupBoxColor>
                     </Grid>
                  )}
                  {ArrObjetos[index].observaciones && (
                     <Grid container item>
                        <GroupBoxColor
                           title={'Observaciones'}
                           borderColorPaper={'#ff5722'}
                           titlePosition={'TopL'}
                           borderRadiusPaper={'20'}
                        >
                           <Typography style={{textAlign: 'justify'}}>
                              {ArrObjetos[index].observaciones}
                           </Typography>
                        </GroupBoxColor>
                     </Grid>
                  )}
               </Grid>

               <Grid container item xs={12} justify="center" style={{marginTop: '0.5rem'}}>
                  <ButtonGroup
                     color="primary"
                     variant="contained"
                     aria-label="contained primary button group"
                     disableElevation
                  >
                     <Button title="Anterior Video" onClick={handleOnClickBeforeVideo}>
                        <DoubleArrow style={{transform: 'rotate(180deg)'}} />
                     </Button>
                     <Button title="Anterior Tutorial" onClick={handleOnClickBeforeTutorial}>
                        <KeyboardArrowLeft />
                     </Button>
                     <Button title="Codigo Tutorial">{ArrObjetos[index].codigo}</Button>
                     <Button title="Siguiente Tutorial" onClick={handleOnClickNextTutorial}>
                        <KeyboardArrowRight />
                     </Button>
                     <Button title="Siguiente Video" onClick={handleOnClickNextVideo}>
                        <DoubleArrow />
                     </Button>
                  </ButtonGroup>
               </Grid>
            </>
         )}
      </Grid>
   );
};

InfoContainer.propTypes = {
   selected: PropTypes.number,
   ArrObjetos: PropTypes.array,
   setIndex: PropTypes.func,
   className: PropTypes.object
};

InfoContainer.defaultProps = {
   ArrObjetos: [],
   setIndex: () => {},
   index: 0,
   className: {}
};
